<template>
  <div
    v-if="eventProtectable && packagesProtectable"
    id="protectGroupForm"
    class="protect-group-form"
  >
    <div
      class="protect-group-refundable open "
    >
      <h2 class="protect-group-title expandable-header">
        *{{ $t('checkout.protectGroup.refundableBooking') }}
      </h2>
    </div>
    <div
      class="refundable-display-box"
      @click="selectRefundable()"
    >
      <div class="refundable-recommended-bubble">
        <div
          class="protect-group-select-container"
        >
          <div>
            <i
              class="protect-group-select refundable"
            >

              <i
                id="refundable-radio"
                class="fa fa-circle small-protect-group-select refundable"
              />
            </i>
          </div>
        </div>
        <div class="refundable-statement">
          <b>{{ $t('checkout.protectGroup.refundableBooking') }}</b>
        </div>
        <div class="protect-group-recommended-bubble-div">
          <div class="protect-group-recommended-bubble">
            {{ $t('checkout.protectGroup.recommended') }}
          </div>
        </div>
      </div>
      <div
        id="eventProtectGroupPremiumAmount"
        class="event-protect-group-premium-amount"
      >
        {{ $store.state.checkout.protectGroupCostDecorated }}
      </div>
    </div>
    <div class="refundable-perks-chart">
      <div class="refundable-perks-chart-row">
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.unexpectedPersonalProblem') }}
        </div>
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.homeEmergency') }}
        </div>
      </div>
      <div class="refundable-perks-chart-row">
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.publicTransportFailure') }}
        </div>
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.relativeSickness') }}
        </div>
      </div>
      <div class="refundable-perks-chart-row">
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.privateVehicleFailure') }}
        </div>
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.preExistingCondition') }}
        </div>
      </div>
      <div class="refundable-perks-chart-row">
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.emergencyRecall') }}
        </div>
        <div class="refundable-perks-chart-cell">
          <i
            class="fa fa-check"
            aria-hidden="true"
          />
          {{ $t('checkout.protectGroup.andManyMore') }}
        </div>
      </div>
      <div class="protect-group-upgrade-statement">
        <p
          v-html="$t('checkout.protectGroup.upgradeStatement')"
        />
      </div>
    </div>
    <div
      class="nonrefundable-display-box"
      @click="selectNonRefundable()"
    >
      <div>
        <i
          class="protect-group-select"
        >
          <i
            id="non-refundable-radio"
            class="fa fa-circle small-protect-group-select refundable"
          />
        </i>
      </div>
      <label> {{ $t('checkout.protectGroup.nonRefundableBooking') }} </label>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import CartApi from '../cart/cart_api'

export default {

  props:['updateterms'],

  data() {
    return {
      eventProtectable: true,
      packagesProtectable: true,
    }
  },


  created(){
    CartApi.getProtectGroupInfo().
      then(info => {
        this.setInitialValues(info)
        if (!info.event_pg_enabled || !info.package_pg_enabled){
          this.$store.state.checkout.protectGroupDecisionMade = true
        }
        info.order_protected ? this.selectRefundable() : null
      })
  },

  methods: {
    ...mapMutations('checkout', [
      'updateCreditAmount',
      'customerMadeProtectGroupDecision'
    ]),
    selectRefundable(){

      this.highlightRefundButton()
      this.emitChange(this.$store.state.checkout.protectGroupCost)
      this.customerMadeProtectGroupDecision()
    },
    selectNonRefundable(){
      this.highlightNonRefundableButton()
      this.emitChange(0)
      this.customerMadeProtectGroupDecision()
    },
    highlightRefundButton(){
      this.clearRadios()
      let radio = document.getElementById('refundable-radio')
      radio.classList.add('chosen')
    },
    highlightNonRefundableButton(){
      this.clearRadios()
      let radio = document.getElementById('non-refundable-radio')
      radio.classList.add('chosen')
    },
    emitChange(amount){
      let body = JSON.stringify(
        { order: { protect_group_amount: amount } }
      )
      CartApi.changeOrder(body).then( order => {
        if( 0 < order.credit_amount - order.total && order.credit_amount - order.total <= 100){
          this.updateCreditAmount(order.total)
        } else {
          this.updateCreditAmount(order.credit_amount)
        }
        this.$emit('updateterms', order)
      })
    },
    setInitialValues(info){
      this.eventProtectable = info.event_pg_enabled
      this.packagesProtectable = info.package_pg_enabled
      this.$store.state.checkout.protectGroupPremiumDecorated = info.event_pg_premium_decorated
      this.$store.state.checkout.protectGroupPremium = info.event_pg_premium
      this.$store.state.checkout.protectGroupCost = info.event_pg_premium
    },
    clearRadios() {
      let packagesForm = document.getElementById('protectGroupForm')
      let radios=packagesForm.getElementsByClassName('small-protect-group-select')
      radios.forEach(radio => {
        radio.classList.remove('chosen')
      })
    },

    selectRadioButton(){
      let packagesForm = document.getElementById('multiplePackagesForm')
      packagesForm.getElementsByClassName('small-protect-group-select')[0].classList.add('chosen')
    },
  }
}
</script>
